export const defaultValues = {
  siren: '', // These are non-editable
  period: '', // These are non-editable
  hoursWorked: '',
  missedAppointments: '',
  newPatients: '',
  treatmentPlansProposed: '',
  crownsPlaced: '',
  activeOrthoPatients: '',
  scheduledAppointments: '',
  patientsTreated: '',
  emergencies: '',
  treatmentPlansAccepted: '',
  implantsPlaced: '',
  revenue: ''
};
